import * as React from "react"
import styled from 'styled-components'

import Seo from './../components/Seo.js'
import Layout from './../components/layout.js'
import BoxAnimation from './../components/BoxAnimation.js'

const StyledHero = styled.section`
	display: flex;
	justify-content: space-around;
	align-items: center;
`

const StyledSplash = styled.article`

`

const StyledIcons = styled.div`
	display: flex;
	justify-content: space-around;
`

const StyledLogoSVG = styled.svg`
	height: 80px;
	margin-bottom: 8px;

    @media (max-width: 656px) {
		margin-bottom: 3vw;
        height: 16vw;
	}
`

const StyledIconSVG = styled.svg`
	height: 16px;

	&:nth-child(2) {
		padding: 0 1.25vw;
	}

    @media (max-width: 656px) {
        height: 4vw;

		&:nth-child(2) {
			padding: 0 4vw;
		}
	}
`

const StyledIconLink = styled.a`
	&:nth-child(2) {
		padding: 0 8px;
	}

	@media (max-width: 656px) {

		&:nth-child(2) {
			padding: 0 4vw;
		}
	}
`

const IndexPage = ({ location: { origin } }) => {
	return (
		<>
			<Seo currentPath={origin}/>
			<Layout root={true}>
				<StyledHero>
					<StyledSplash>
						<StyledLogoSVG viewBox="0 0 164 41">
							<defs>
								<linearGradient x1="0%" y1="50.001%" x2="100%" y2="50.001%" id="a">
									<stop stopColor="#26295C" offset="0%"/>
									<stop stopColor="#D21D52" offset="100%"/>
								</linearGradient>
								<linearGradient x1="32.454%" y1=".597%" x2="67.568%" y2="99.381%" id="c">
									<stop stopColor="#26295C" offset="0%"/>
									<stop stopColor="#45ABA7" offset="100%"/>
								</linearGradient>
								<radialGradient cx="81.457%" cy="9.318%" fx="81.457%" fy="9.318%" r="108.315%" gradientTransform="matrix(-.38075 .5693 -.92468 -.23442 1.21 -.349)" id="b">
									<stop stopColor="#D31D59" offset="0%"/>
									<stop stopColor="#45ABA8" offset="100%"/>
								</radialGradient>
							</defs>
							<g fill="none" fillRule="evenodd">
								<path d="M18.186.172L4.599 8.016a1.278 1.278 0 00.64 2.388h.001c.217 0 .437-.055.639-.171l12.947-7.475 12.948 7.475a1.28 1.28 0 001.28-2.216L19.465.171a1.276 1.276 0 00-1.28 0" fill="url(#a)" transform="translate(0 .412)"/>
								<path d="M35.806 11.252L20.99 19.783a1.278 1.278 0 00-.642 1.109v17.132a1.28 1.28 0 001.28 1.28c.221 0 .442-.058.64-.172l14.816-8.555a1.28 1.28 0 00-1.28-2.216l-12.896 7.447V21.632l14.174-8.161a1.278 1.278 0 00-.64-2.389c-.216 0-.435.054-.636.17" fill="url(#b)" transform="translate(0 .412)"/>
								<path d="M.64 11.254c-.397.228-.64.65-.64 1.107V29.47c0 .457.244.88.64 1.107l14.816 8.555a1.277 1.277 0 001.282-.001c.396-.23.64-.655.637-1.113l-.04-8.554a1.279 1.279 0 00-.641-1.104l-3.943-2.27a1.28 1.28 0 00-1.277 2.219l3.305 1.903.027 5.59L2.559 28.73V14.574l12.898 7.427a1.28 1.28 0 101.277-2.218L1.918 11.252a1.278 1.278 0 00-1.278.002" fill="url(#c)" transform="translate(0 .412)"/>
								<path d="M150.755 22.874l1.205-6.948c.06-.396.12-.792.159-1.208.06.436.118.871.198 1.307l1.162 6.85h-2.724zm3.541 4.81h1.03l-2.534-14.054h-1.346l-2.554 14.054h1.03l.675-3.9h3.037l.662 3.9zM157.978 27.684V13.71h.97v13.105h4.612v.87zM76.448 27.684V13.71h.97v13.105h4.612v.87zM52.596 14.58v5.384h3.999v.852h-3.999v5.998h3.98v.87h-4.93V13.71h4.949v.87zM63.246 27.684l-3.247-12.79.08 12.79h-.931V13.71h1.425l3.346 13.029-.139-13.03h.95v13.976zM70.983 26.6H69.32V21.16h.99c.93 0 1.979.119 2.355 1.148.099.297.12.614.12.95v1.398c0 .797-.05 1.26-.283 1.595-.585.402-1.333.349-1.52.349zm0-11.806c.186 0 .934-.054 1.519.349.232.334.282.798.282 1.594v1.477c0 .337-.02.653-.119.95-.376 1.03-1.425 1.148-2.355 1.148h-.99v-5.518h1.663zm2.771 3.4v-1.892c0-.752-.08-1.445-.693-2-.732-.633-1.663-.593-1.94-.593H68.33v13.976h2.791c.277 0 1.208.04 1.94-.594.614-.555.693-1.247.693-2v-1.813c0-.732-.02-1.524-.653-2.059-.345-.292-.802-.421-1.128-.483.326-.06.783-.191 1.128-.483.633-.535.653-1.326.653-2.059zM88.285 17.648c0-1.168-.06-1.821-.337-2.356a1.365 1.365 0 00-.634-.653 1.96 1.96 0 00-.93-.218c-.554 0-.91.198-1.069.297-.851.555-.811 1.663-.811 1.9v7.701c0 .792.04 1.227.158 1.584.138.376.633 1.089 1.742 1.089.396 0 .772-.1 1.089-.337.752-.535.792-1.386.792-2.197v-6.81zm.514 9.007c-.297.515-1.03 1.208-2.455 1.208-.276 0-1.484-.02-2.177-.851-.554-.694-.614-1.485-.614-2.317v-7.879c0-.157 0-.95.218-1.583.396-1.168 1.485-1.702 2.672-1.683.634 0 1.267.139 1.782.515.99.752.99 1.96.99 3.049v7.72c0 .653-.06 1.247-.416 1.821zM97.746 26.338c-.257.733-.95 1.564-2.672 1.564-1.663 0-2.337-1.108-2.534-1.702-.139-.416-.198-.812-.198-1.683v-7.581c0-.852-.02-1.604.515-2.316.554-.773 1.365-1.05 2.256-1.05 1.05 0 2.059.416 2.455 1.446.198.494.198 1.108.198 1.247v1.96h-.95v-.931c0-1.05-.02-1.624-.258-2.079a1.358 1.358 0 00-.515-.515 1.688 1.688 0 00-.91-.237c-.178 0-.594.02-1.01.277-.89.535-.83 1.683-.83 1.92v6.89c0 .752-.06 1.94.355 2.632.139.257.337.436.574.574.416.218.832.238 1.01.238.435 0 .713-.12.871-.198.871-.456.831-1.426.831-1.683v-2.237h.99v2.158c0 .693-.06.97-.178 1.306M105.406 27.684l-2.553-7.244-1.03 1.94v5.304h-.95V13.71h.97v6.85l3.484-6.85h1.089l-2.97 5.562 3.01 8.413zM118.846 26.338c-.258.733-.951 1.564-2.673 1.564-1.663 0-2.336-1.108-2.534-1.702-.138-.416-.198-.812-.198-1.683v-7.581c0-.852-.02-1.604.515-2.316.554-.773 1.366-1.05 2.257-1.05 1.049 0 2.058.416 2.454 1.446.198.494.198 1.108.198 1.247v1.96h-.95v-.931c0-1.05-.02-1.624-.258-2.079a1.358 1.358 0 00-.514-.515 1.688 1.688 0 00-.91-.237c-.179 0-.594.02-1.01.277-.89.535-.831 1.683-.831 1.92v6.89c0 .752-.06 1.94.355 2.632.14.257.337.436.575.574.415.218.832.238 1.01.238.435 0 .712-.12.87-.198.872-.456.832-1.426.832-1.683v-2.237h.99v2.158c0 .693-.06.97-.178 1.306M134.879 17.193c0-1.247-.02-1.92-.575-2.336-.356-.277-.672-.336-1.484-.336h-1.485v5.978h1.584c.534 0 1.089-.06 1.505-.495.534-.535.455-1.485.455-1.604v-1.207zm.396 3.227c-.713.85-1.881.89-2.495.89h-1.425v6.374h-.97V13.71h2.178c.85 0 1.8-.04 2.513.554.753.614.753 1.524.753 2.554V18.4c0 .752-.02 1.386-.554 2.02zM138.797 27.684h1.01V13.71h-1.01zM145.508 14.58v13.105h-.99V14.58h-2.435v-.871h5.9v.87zM47.654 24.676c0 .435-.02 1.068-.198 1.485-.178.395-.627.89-1.637.89-.06 0-.13.002-.229-.004-.873-.039-1.309-.679-1.443-.966-.21-.419-.26-.908-.273-1.694l-.004-7.194c0-.871-.08-1.801.673-2.435.475-.376 1.029-.376 1.227-.376 1.01 0 1.445.495 1.623.89.178.416.198 1.05.198 1.485v1.445h.93v-1.94c0-.079 0-.653-.098-1.029-.218-.712-.852-1.683-2.594-1.683-.93 0-1.425.198-1.781.436a1.87 1.87 0 00-.456.376c-.613.614-.672 1.564-.672 2.375l.004 7.958c0 .34.024.677.092 1.011.079.44.213.77.438 1.107.036.056.096.145.188.258.067.073.127.13.184.18.463.42 1.088.631 1.726.631 0 0 .033 0 0 0 0 0 .263.002.327 0 1.773-.03 2.433-.97 2.651-1.682.1-.376.1-.95.1-1.03l-.01-3.86h-3.028v.851h2.059l.003 2.515zM123.163 22.874l1.205-6.948c.06-.396.118-.792.158-1.208.06.436.119.871.198 1.307l1.163 6.85h-2.724zm3.54 4.81h1.03L125.2 13.63h-1.346L121.3 27.684h1.029l.676-3.9h3.037l.661 3.9z" fill="#060101"/>
							</g>
						</StyledLogoSVG>
						<StyledIcons>
							<div>
								<StyledIconLink href="https://twitter.com/GenblockCapital">
									<StyledIconSVG viewBox="0 0 176 142">
										<path d="M55.53 142c66.016 0 102.147-54.645 102.147-102.029 0-1.56 0-3.12-.108-4.625A73.485 73.485 0 00175.5 16.79a72.507 72.507 0 01-20.623 5.648c7.485-4.465 13.085-11.51 15.777-19.847-7.054 4.195-14.754 7.1-22.777 8.713C134.254-3.164 111.53-3.809 97.1 9.744c-9.315 8.767-13.3 21.837-10.392 34.261-28.862-1.452-55.785-15.06-73.985-37.488-9.53 16.405-4.685 37.327 11.092 47.868-5.707-.16-11.307-1.72-16.315-4.464v.43c0 17.05 12.062 31.787 28.808 35.176a35.129 35.129 0 01-16.208.591c4.685 14.63 18.2 24.633 33.546 24.902-12.708 10.004-28.43 15.436-44.584 15.383-2.854 0-5.708-.162-8.562-.538C16.923 136.46 36.038 142 55.53 142" fill="#000" fillRule="nonzero"/>
									</StyledIconSVG>
								</StyledIconLink>
								<StyledIconLink href="https://medium.com/@Genblock-Capital">
									<StyledIconSVG viewBox="0 0 181 144">
										<path d="M21.61 29.727c.25-2.258-.628-4.39-2.257-5.895L2.556 3.51V.5h52.145l40.362 88.56L130.537.5H180.3v3.01L165.885 17.31c-1.254 1.003-1.88 2.509-1.63 4.014v101.354c-.25 1.505.376 3.136 1.63 4.014l14.039 13.798v3.011h-70.571v-3.01l14.54-14.175c1.38-1.38 1.38-1.882 1.38-4.014V40.389L84.91 143.124h-5.515L32.389 40.389v68.866c-.376 2.885.627 5.77 2.632 7.903l18.928 22.955v3.01H.3v-3.01l18.928-22.955c2.005-2.133 2.883-5.018 2.381-7.903V29.727z" fill="#000" fillRule="nonzero"/>
									</StyledIconSVG>
								</StyledIconLink>
								<StyledIconLink href="https://www.linkedin.com/company/genblock-capital/">
									<StyledIconSVG viewBox="0 0 142 142">
										<path d="M131.5 0h-121C4.7 0 0 4.6 0 10.2v121.5c0 5.7 4.7 10.2 10.5 10.2h121c5.8 0 10.5-4.6 10.5-10.2V10.2C142 4.6 137.3 0 131.5 0zM42.1 121H21V53.2h21.1V121zM31.6 44c-6.8 0-12.2-5.5-12.2-12.2 0-6.7 5.5-12.2 12.2-12.2 6.7 0 12.2 5.5 12.2 12.2 0 6.7-5.5 12.2-12.2 12.2zm89.4 77h-21V88c0-7.9-.1-18-10.9-18-11 0-12.6 8.6-12.6 17.4V121h-21V53.2h20.2v9.3h.3c2.8-5.3 9.7-10.9 19.9-10.9 21.3 0 25.2 14 25.2 32.3V121h-.1z" fill="#000" fillRule="nonzero"/>
									</StyledIconSVG>
								</StyledIconLink>
							</div>
						</StyledIcons>
					</StyledSplash>
					<BoxAnimation/>
				</StyledHero>
			</Layout>
		</>
	)
}

export default IndexPage
